import { TPagination } from "@/types";
import { api } from ".";

type TPaginate = Pick<TPagination, "page" | "limit" | "search">;

const memberApi = {
  create: async (body: {}) => {
    return await api.post("members", body);
  },

  myDownliners: async ({ page, limit, search }: TPaginate) => {
    return await api.get(
      `members/my-downliners?page=${page}&limit=${limit}&search=${search}`
    );
  },

  updateDownlinerMemberId: async (body: {}) => {
    return await api.post("members/downliner-memberId", body);
  },

  getById: async (id: number) => {
    return await api.get(`members/${id}`);
  },
};

export default memberApi;
